/**
 * Announcement Bar Countdown Timer
 * Updates countdown display every second until the end date is reached
 * Uses Madrid timezone (Europe/Madrid)
 */

(function() {
  'use strict';

  // Get countdown container
  const countdownElement = document.querySelector('.announcement-bar--countdown');
  if (!countdownElement) return;

  // Get end date, timezone, and infinite loop from data attributes
  const endDateString = countdownElement.getAttribute('data-countdown-end');
  const timezone = countdownElement.getAttribute('data-timezone') || 'Europe/Madrid';
  const infiniteLoop = countdownElement.getAttribute('data-infinite-loop') === 'true';

  if (!infiniteLoop && !endDateString) return;

  /**
   * Pad number with leading zero if less than 10
   */
  function padNumber(num) {
    return num < 10 ? '0' + num : num.toString();
  }

  /**
   * Get current time in Madrid timezone
   */
  function getMadridTime() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
  }

  /**
   * Get end of today (23:59:59) in Madrid timezone
   */
  function getEndOfToday() {
    var now = getMadridTime();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  }

  // Parse end date - treat input as Madrid time
  let endDate;
  if (infiniteLoop) {
    endDate = getEndOfToday();
  } else {
    endDate = new Date(endDateString);
    if (isNaN(endDate.getTime())) {
      console.error('Invalid countdown end date:', endDateString);
      return;
    }
  }

  // Get countdown value elements
  const daysElement = countdownElement.querySelector('[data-unit="days"]');
  const hoursElement = countdownElement.querySelector('[data-unit="hours"]');
  const minutesElement = countdownElement.querySelector('[data-unit="minutes"]');
  const secondsElement = countdownElement.querySelector('[data-unit="seconds"]');

  if (!daysElement || !hoursElement || !minutesElement || !secondsElement) {
    console.error('Countdown unit elements not found');
    return;
  }

  /**
   * Update countdown display
   */
  function updateCountdown() {
    // Get current time in Madrid timezone
    const now = getMadridTime();
    const timeRemaining = endDate - now;

    // Check if countdown has expired
    if (timeRemaining <= 0) {
      if (infiniteLoop) {
        // Reset to end of next day
        endDate = getEndOfToday();
        return;
      }

      daysElement.textContent = '00';
      hoursElement.textContent = '00';
      minutesElement.textContent = '00';
      secondsElement.textContent = '00';

      // Stop the interval
      if (window.countdownInterval) {
        clearInterval(window.countdownInterval);
      }

      // Show expired message
      const expiredMessage = window.theme?.translations?.countdown?.expired || 'Offer has ended!';
      if (countdownElement.parentElement) {
        const contentWrapper = countdownElement.parentElement.querySelector('.announcement-bar--content-wrapper');
        if (contentWrapper) {
          contentWrapper.innerHTML =
            '<div class="announcement-bar--item" style="text-align: center; width: 100%;">' + expiredMessage + '</div>';
        }
        countdownElement.style.display = 'none';
      }

      return;
    }

    // Calculate time units
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Update display with padded values
    daysElement.textContent = padNumber(days);
    hoursElement.textContent = padNumber(hours);
    minutesElement.textContent = padNumber(minutes);
    secondsElement.textContent = padNumber(seconds);
  }

  // Initial update
  updateCountdown();

  // Update every second
  window.countdownInterval = setInterval(updateCountdown, 1000);

  // Clean up on page unload
  window.addEventListener('beforeunload', function() {
    if (window.countdownInterval) {
      clearInterval(window.countdownInterval);
    }
  });
})();
